function getDisplaySigFigs(digits) {
  if (digits > 6) {
    // 1,000,000 or higher
    return 4;
  }

  if (digits > 4) {
    // 10,000 or higher
    return 3; // e.g., 42,300
  }

  if (digits > 3) {
    // 1,000 or higher
    return 3; // e.g., 1,400
  }

  return 2; // e.g., 500, 50, 1
}

function getNumberOfDigits(val) {
  var digits = 1;
  var absVal = Math.abs(val);

  while (absVal > 10) {
    absVal /= 10;
    digits += 1;
  }

  return digits;
}

function formatNumberWithUnit(value) {
  if (value < 1000) {
    // 9,000 = $9,000
    return value;
  } else if (value < 1000000) {
    // 10,000 = $10K
    // 9,000,000 = $900K
    return "".concat(value / 1000, "K");
  } else if (value < 1000000000) {
    // 10,000,000 = $10M
    // 900,000,000 = $900M
    return "".concat(value / 1000 / 1000, "M");
  } // 10,000,000,000 = $10B
  // 900,000,000,000 = $900B


  return "".concat(value / 1000 / 1000 / 1000, "B");
}

export default (function (val) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (typeof val === 'number') {
    var digits = getNumberOfDigits(val);
    var sigfigs = getDisplaySigFigs(digits);
    var k = Math.pow(10, digits - sigfigs);
    var finalVal = Math.round(val / k) * k;
    return format ? formatNumberWithUnit(finalVal) : finalVal;
  }

  return null;
});